// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var BrowserComponents_Input = require("./BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("./BrowserComponents_Button.bs.js");
var BrowserComponents_FlexRow = require("./BrowserComponents_FlexRow.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexBasis("auto"),
      tl: {
        hd: BrowserStyle.marginTop(BrowserStyle.rem(1.5)),
        tl: /* [] */0
      }
    });

var button = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Grey */2,
            _0: /* Medium */2
          }),
      tl: {
        hd: BrowserStyle.border(BrowserStyle.rem(0.125), BrowserStyle.solid, {
              TAG: /* Grey */2,
              _0: /* Medium */2
            }),
        tl: {
          hd: BrowserStyle.padding(BrowserStyle.rem(1.125)),
          tl: {
            hd: BrowserStyle.outlineStyle(BrowserStyle.none),
            tl: {
              hd: BrowserStyle.cursor("pointer"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var leftButton = Curry._1(BrowserStyle.merge, {
      hd: button,
      tl: {
        hd: Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.borderTopLeftRadius(BrowserStyle.rem(0.5)),
              tl: {
                hd: BrowserStyle.borderBottomLeftRadius(BrowserStyle.rem(0.5)),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var rightButton = Curry._1(BrowserStyle.merge, {
      hd: button,
      tl: {
        hd: Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.borderTopRightRadius(BrowserStyle.rem(0.5)),
              tl: {
                hd: BrowserStyle.borderBottomRightRadius(BrowserStyle.rem(0.5)),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var inputContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.border(BrowserStyle.em(0.125), BrowserStyle.solid, {
              TAG: /* Grey */2,
              _0: /* Medium */2
            }),
        tl: {
          hd: BrowserStyle.display(BrowserStyle.flexBox),
          tl: {
            hd: BrowserStyle.justifyContent(BrowserStyle.center),
            tl: {
              hd: BrowserStyle.padding2(BrowserStyle.rem(0.75), BrowserStyle.rem(0.875)),
              tl: {
                hd: BrowserStyle.width("auto"),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var count = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, /* OpenSans */1, /* XXLarge */6, undefined)({
          hd: BrowserStyle.border(BrowserStyle.zero, BrowserStyle.solid, /* Transparent */2),
          tl: {
            hd: BrowserStyle.textAlign(BrowserStyle.center),
            tl: {
              hd: BrowserStyle.width(BrowserStyle.rem(3.0)),
              tl: /* [] */0
            }
          }
        }));

var Style = {
  container: container,
  button: button,
  leftButton: leftButton,
  rightButton: rightButton,
  inputContainer: inputContainer,
  count: count
};

function BrowserComponents_Counter$Stateless(Props) {
  var className = Props.className;
  var count$1 = Props.count;
  var maxOpt = Props.max;
  var minOpt = Props.min;
  var setCount = Props.setCount;
  var testId = Props.testId;
  var max = maxOpt !== undefined ? maxOpt : 999;
  var min = minOpt !== undefined ? minOpt : 1;
  var partial_arg = Curry._3(Relude_Int.clamp, min, max, count$1 - 1 | 0);
  var partial_arg$1 = function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
  var partial_arg$2 = Curry._2(Relude_Int.clamp, min, max);
  var partial_arg$3 = function (param) {
    return Relude_Globals.$great$great(partial_arg$2, setCount, param);
  };
  var partial_arg$4 = function (param) {
    return Relude_Globals.$great$great(partial_arg$3, IOUtils.unsafeRunHandledAsync, param);
  };
  var partial_arg$5 = function (param) {
    return Relude_Option.fold(undefined, partial_arg$4, param);
  };
  var partial_arg$6 = function (param) {
    return Relude_Globals.$great$great(Relude_Int.fromString, partial_arg$5, param);
  };
  var partial_arg$7 = function (param) {
    return Relude_IO.map(partial_arg$6, param);
  };
  var partial_arg$8 = Curry._3(Relude_Int.clamp, min, max, count$1 + 1 | 0);
  var partial_arg$9 = function (param) {
    return Relude_Globals.$$const(partial_arg$8, param);
  };
  var tmp = {
    children: React.createElement(BrowserComponents_FlexRow.make, {
          className: BrowserStyle.Utils.extendBaseStyle(container, className),
          children: null
        }, React.createElement(ReactUtils.WithTestId.make, {
              id: "decrement",
              children: React.createElement(BrowserComponents_Button.Icon.make, {
                    className: leftButton,
                    icon: {
                      TAG: /* Small */1,
                      _0: {
                        TAG: /* Navigation */5,
                        _0: /* Minus */4
                      }
                    },
                    iconColor: {
                      TAG: /* White */7,
                      _0: /* Light */2
                    },
                    onClick: (function (param) {
                        return Relude_Globals.$great$great(partial_arg$1, setCount, param);
                      })
                  })
            }), React.createElement("div", {
              className: inputContainer
            }, React.createElement(BrowserComponents_Input.BaseStatefulStyleType.make, {
                  className: count,
                  value: {
                    TAG: /* Text */7,
                    _0: {
                      onChange: (function (param) {
                          return Relude_Globals.$great$great(Relude_IO.pure, partial_arg$7, param);
                        }),
                      value: Relude_Int.toString(count$1)
                    }
                  }
                })), React.createElement(ReactUtils.WithTestId.make, {
              id: "Increment",
              children: React.createElement(BrowserComponents_Button.Icon.make, {
                    className: rightButton,
                    icon: {
                      TAG: /* Small */1,
                      _0: {
                        TAG: /* Navigation */5,
                        _0: /* Plus */7
                      }
                    },
                    iconColor: {
                      TAG: /* White */7,
                      _0: /* Light */2
                    },
                    onClick: (function (param) {
                        return Relude_Globals.$great$great(partial_arg$9, setCount, param);
                      })
                  })
            }))
  };
  if (testId !== undefined) {
    tmp.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(ReactUtils.WithTestId.make, tmp);
}

var Stateless = {
  make: BrowserComponents_Counter$Stateless
};

function BrowserComponents_Counter(Props) {
  var className = Props.className;
  var maxOpt = Props.max;
  var minOpt = Props.min;
  var initialCountOpt = Props.initialCount;
  var onUpdate = Props.onUpdate;
  var testId = Props.testId;
  var max = maxOpt !== undefined ? maxOpt : 999;
  var min = minOpt !== undefined ? minOpt : 1;
  var initialCount = initialCountOpt !== undefined ? initialCountOpt : 0;
  var match = ReactIO.useState(function (param) {
        return initialCount;
      });
  var setCount = match[1];
  var setCount$1 = function (a) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(onUpdate, a);
                }), Curry._1(setCount, a));
  };
  var tmp = {
    count: match[0],
    max: max,
    min: min,
    setCount: setCount$1
  };
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (testId !== undefined) {
    tmp.testId = Caml_option.valFromOption(testId);
  }
  return React.createElement(BrowserComponents_Counter$Stateless, tmp);
}

var Icon;

var defaultMin = 1;

var defaultMax = 999;

var make = BrowserComponents_Counter;

exports.Icon = Icon;
exports.Style = Style;
exports.defaultMin = defaultMin;
exports.defaultMax = defaultMax;
exports.Stateless = Stateless;
exports.make = make;
/* container Not a pure module */
